import React from "react";
import "./About.css";
import AboutImg from "../../Assests/Images/carousal-carpet.jpg";

export default function About() {
  return (
    <section id="about-main" className="about-section">
      <div className="about-inner">
        <header className="about-header">
          <h2 className="about-title">About Us</h2>
          <div className="about-underline" />
          <p className="about-subtitle">
            Delivering spotless perfection with care, experience, and trust.
          </p>
        </header>

        <div className="about-container">
          <div className="about-left">
            {/* use loading="lazy" for better performance on mobile */}
            <img
              src={AboutImg}
              alt="SaafSafaiWale cleaning service"
              className="about-img"
              loading="lazy"
            />
          </div>

          <div className="about-right">
            <p className="about-description">
              At <strong>SaafSafaiWale</strong>, we are a trusted provider of
              professional cleaning services with years of industry experience.
              Our mission is to make every home and workspace shine with
              excellence. From <strong>facade cleaning</strong> to{" "}
              <strong>deep cleaning</strong>, <strong>carpet washing</strong>, and{" "}
              <strong>floor polishing</strong> — we handle every task with
              precision, care, and commitment to quality.
            </p>

            <div className="about-grid">
              <article className="about-card">
                <div className="about-icon-wrap">
                  <i className="fa-solid fa-briefcase about-icon" />
                </div>
                <h4>10+ Years Experience</h4>
                <p>
                  A decade of delivering excellence through expert cleaning
                  solutions trusted by homes and businesses alike.
                </p>
              </article>

              <article className="about-card">
                <div className="about-icon-wrap">
                  <i className="fa-solid fa-hand-sparkles about-icon" />
                </div>
                <h4>Premium Quality</h4>
                <p>
                  We use eco-friendly products and professional equipment to
                  ensure spotless, long-lasting results.
                </p>
              </article>

              <article className="about-card">
                <div className="about-icon-wrap">
                  <i className="fa-solid fa-people-group about-icon" />
                </div>
                <h4>Skilled Professionals</h4>
                <p>
                  Our trained and dedicated team ensures that each job is
                  completed with perfection and reliability.
                </p>
              </article>

              <article className="about-card">
                <div className="about-icon-wrap">
                  <i className="fa-solid fa-shield-halved about-icon" />
                </div>
                <h4>Safe & Trusted</h4>
                <p>
                  We follow strict hygiene and safety standards to protect your
                  family, employees, and environment.
                </p>
              </article>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
